import { AccessToken } from '@okta/okta-auth-js';

const SetAuthHeader = (accessToken: AccessToken) => {
    var headers = new Headers();
    var bearer = "Bearer " + accessToken.accessToken;
    headers.append("Authorization", bearer);
    headers.append("Content-Type", "application/json");
    return {
        method: "GET",
        headers
    }
}

export default SetAuthHeader;

export const ManageResponseErrors = (response: any) => {
    if (!response.ok) {
        console.log(response);
        const displayText = () => {
            switch (response.status) {
                case 404:
                    return 'Not Found';
                case 401:
                    return 'Unauthorized';
                case 500:
                    return 'Unhandled Error in API';
                default:
                    return response.statusText;
            }
        }
        const responseError = {
            statusText: displayText(),
            status: response.status
        };

        throw (responseError);
    }
}